export default __webpack_public_path__ + "static/media/310.3e861b6f.gif";